const PASSWORD_MIN_LENGTH = 5;

function validateEmailField(emailElem, state) {
    const value = emailElem.querySelector('input').value;
    const isValid = validateEmail(value);

    if (!state.shouldValidate) {
        return isValid;
    }

    const fieldWrapper = emailElem.querySelector('.tv-login-form__input-wrapper');
    const fieldErrorContainer = emailElem.querySelector('.tv-login-form__field-error');

    if (isValid) {
        fieldWrapper.classList.remove('tv-login-form__input-invalid');
        fieldErrorContainer.classList.add('hidden');
    } else {
        fieldWrapper.classList.add('tv-login-form__input-invalid');
        fieldErrorContainer.classList.remove('hidden')
    }

    return isValid;
}

function validatePasswordField(passwordElem, state) {
    const value = passwordElem.querySelector('input').value;
    const isValid = value.trim().length >= PASSWORD_MIN_LENGTH;

    if (!state.shouldValidate) {
        return isValid;
    }

    const fieldWrapper = passwordElem.querySelector('.tv-login-form__input-wrapper');
    const fieldErrorContainer = passwordElem.querySelector('.tv-login-form__field-error');

    if (isValid) {
        fieldWrapper.classList.remove('tv-login-form__input-invalid');
        fieldErrorContainer.classList.add('hidden');
    } else {
        fieldWrapper.classList.add('tv-login-form__input-invalid');
        fieldErrorContainer.classList.remove('hidden')
    }

    return isValid;
}
